export default "__VITE_ASSET__Dbyska7V__"